import React, { useState } from "react";
import axios from "axios";
import { useLocation } from "wouter";
import "./Register.css";

export default function Register() {

  const [email, setEmail]   = useState("");
  const [regid, setRegid]   = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [, setLocation] = useLocation();

  // ✅ Always call backend via PRIMARY domain
  const BACKEND_URL =
    "https://recstudentportal.com/ram/app/signupotp_web.php";

  async function sendOTP() {

    // ---------- Frontend validation ----------
    if (!email.includes("@")) {
      alert("Enter a valid email address");
      return;
    }

    if (regid.trim().length < 3) {
      alert("Enter a valid Student ID");
      return;
    }

    if (!/^[0-9]{10}$/.test(mobile)) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        BACKEND_URL,
        {
          email: email.trim(),
          regid: regid.trim(),
          mobile: mobile.trim()
        },
        {
          headers: { "Content-Type": "application/json" },
          timeout: 20000
        }
      );

      // ✅ Axios already gives parsed JSON
      const data = res.data;
      console.log("OTP Response →", data);

      // ---------- Handle backend statuses ----------
      if (data.status === 0) {
        alert(data.message || "OTP sent successfully");
        localStorage.setItem("otp_server", data.otp);
        setLocation(`/otp?email=${email}&regid=${regid}`);
      }
      else if (data.status === 2) {
        alert(data.message || "Account already exists");
        setLocation("/login");
      }
      else if (data.status === 3) {
        alert(data.message || "Invalid details provided");
      }
      else {
        alert(data.message || "OTP failed");
      }

    } catch (err) {
      console.error("Backend error →", err);
      alert("Server not reachable. Please try again later.");
    }

    setLoading(false);
  }

  return (
    <div className="register-wrapper">
      <div className="register-card">

        <h2>REGISTER</h2>
        <p>Create your student portal account</p>

        <input
          type="text"
          placeholder="Student ID"
          value={regid}
          onChange={e => setRegid(e.target.value)}
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />

        <input
          type="text"
          placeholder="Mobile Number"
          value={mobile}
          onChange={e => setMobile(e.target.value)}
        />

        <button disabled={loading} onClick={sendOTP}>
          {loading ? "Sending..." : "Send OTP"}
        </button>

        <p>
          Already Registered?{" "}
          <span onClick={() => setLocation("/login")}>Login</span>
        </p>

      </div>
    </div>
  );
}
